import appButton from 'components/Button/index'
import {
    mapMutations
} from 'vuex'
export default {
    data () {
        return {
            labelPosition: 'right'
        }
    },
    methods: {
        ...mapMutations('base', ['SET_POP'])
    },
    components: {
        appButton
    }
}
